webpackJsonp([8,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _SiteHeader = __webpack_require__(648);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	var _SiteFooter = __webpack_require__(647);
	
	var _SiteFooter2 = _interopRequireDefault(_SiteFooter);
	
	var _setCookie = __webpack_require__(75);
	
	var _setCookie2 = _interopRequireDefault(_setCookie);
	
	var _i18n = __webpack_require__(16);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  i18n: _i18n2.default,
	  el: '#header',
	  data: {
	    isLogin: false,
	    userId: null,
	    userName: null
	  },
	  created: function created() {
	    var userId = (0, _setCookie2.default)('userId');
	    var cUserId = (0, _setCookie2.default)('cUserId');
	
	    if (userId && cUserId) {
	      var userName = (0, _setCookie2.default)('XM_' + userId + '_UN');
	      this.userId = userId;
	      this.isLogin = true;
	
	      if (userName) {
	        this.userName = userName;
	      } else {
	        if (false) {
	          this.userName = userId;
	          return false;
	        }
	
	        this.getUserName(this.userId);
	      }
	    }
	
	    return true;
	  },
	
	  methods: {
	    getUserName: function getUserName(uid) {
	      var _this = this;
	
	      var script = document.createElement('script');
	      script.src = 'http://account.xiaomi.com/pass/userInfoJsonP?userId=' + uid + '&callback=setLoginInfo_getAccountInfo';
	      script.type = 'text/javascript';
	      script.async = true;
	      document.getElementsByTagName('head')[0].appendChild(script);
	
	      window.setLoginInfo_getAccountInfo = function (data) {
	        if (_this.userId) {
	          _this.userName = data.miliaoInfo.nickName ? data.miliaoInfo.nickName : data.userId;
	          (0, _setCookie2.default)('XM_' + data.userId + '_UN', _this.userName, {
	            path: '/',
	            domain: '.mi.com' });
	        }
	      };
	    }
	  },
	  render: function render(h) {
	    return h(_SiteHeader2.default);
	  }
	});
	
	new _vue2.default({
	  el: '#footer',
	  render: function render(h) {
	    return h(_SiteFooter2.default);
	  }
	});
	
	jQuery(function ($) {
	  function resizeMinHeight() {
	    var $main = $('.site-main');
	    $main.css('min-height', $(window).height() - 45 - 40 - 20 - parseInt($main.css('margin-top'), 10));
	  }
	
	  resizeMinHeight();
	  $(window).on('resize', resizeMinHeight);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueI18n = __webpack_require__(44);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueI18n2.default);
	
	var messages = {
	  en: {
	    Homepage: {
	      services1: 'Storage Service',
	      instruction1: 'Provide powerful storage service of Mi.com',
	      services2: 'After-sale Service',
	      instruction2: 'Make complicated After sale Service simple',
	      services3: 'Refund Service',
	      instruction3: 'Mature and reliable Refund Service',
	      services4: 'Other Service',
	      instruction4: 'Other Service'
	    },
	    Content: {
	      tittle1: 'Business Cooperation',
	      subtittle11: 'Scope of business:',
	      subcontent11: 'XiaomI open platform will open some API related to e-commerce services,including orders,warehousing,after-sales service,customer service,etc. If your company have business contacts with Xiaomi, you need to use some of these services and contact us.',
	      subtittle12: 'E-mail:',
	      subcontent12: 'OPEN-API@xiaomi.com',
	
	      tittle2: 'problem',
	      subtittle21: 'technical question:',
	      subcontent21: 'If you have any technical problems with Xiaomi open platform,such as: API application, SDK usage,access rights,etc. Please contact us.',
	      subtittle22: 'E-mail:',
	      subcontent22: 'OPEN-API@xiaomi.com',
	
	      tittle3: 'Access Application',
	      subtittle31: 'Application question:',
	      subcontent31: 'If you have any questions about the application process, such as to be developer, application  cteation and API, please contact us.',
	      subtittle32: 'E-mail:',
	      subcontent32: 'OPEN-API@xiaomi.com',
	
	      tittle4: 'Open Plat Communicaton Group',
	      subtittle4: 'QQ：226281810'
	    },
	    dashboard: {
	      ApiListTittle1: 'Business Scenario',
	      ApiListTittle2: 'Description',
	      ApiListTittle3: 'Operation',
	      AppListStatus0: 'Apply',
	      AppListStatus1: 'Pending',
	      AppListStatus2: 'Passed',
	      AppListStatus3: 'Rejected',
	
	      PageMyApplyStatus0: 'Pending',
	      PageMyApplyStatus1: 'Passed',
	      PageMyApplyStatus2: 'Rejected',
	      AppListData: 'no data',
	      view: 'view',
	      edit: 'edit',
	      delete: 'delete',
	      appListTittle1: 'Name',
	      appListTittle2: 'Status',
	      appListTittle3: 'Description',
	      appListTittle4: 'Operation',
	      appListStatus: 'passed',
	      appListDelete: 'Are you sure to delete',
	      appListCancel: 'Cancel',
	      appListSave: 'Sure',
	
	      appNavList1: 'Application Overview',
	      appNavList2: 'API Apply',
	      appNavList3: 'SDK Manage',
	
	      appNavList5: 'The Log View',
	      appNavList6: 'Call details',
	
	      navLink1: 'Application List',
	      navLink2: 'My Request',
	      navLink3: 'Sandbox Tools',
	      noApiData: 'You have not called any API yet, there is no statistics',
	      pageAddLabel1: 'Application Name',
	      pageAddLabel2: 'Application Introduction',
	      pageAddLabel3: 'IP Write List(Split by Semicolon)',
	      pageAddLabel3Tips: 'Multiple IP are separated by semicolons, and the segments are recorded in a mask format, such as: 10.236.134.0/24',
	      pageAddLabel4: 'Call Quota per Day',
	      pageAddInvalid1: 'Do not be empty',
	      pageAddInvalid2: 'Not the correct IP address',
	      pageAddInvalid3: 'Less than or equal to 1000000',
	      pageAddSubmit: 'Submit',
	      selectOption: 'Please select a scene and API to see the statistical data',
	      pageAppDetail1: 'Visit Flux',
	      pageAppDetail2: 'API Call Count',
	      pageAppDetail3: 'API Error Rate',
	      newtab: 'New application',
	
	      sandboxLabel1: 'API Group',
	      sandboxLabel2: 'API Name',
	      sandboxLabel3: 'API Environment',
	      sandboxLabel4: 'API Request Parameters',
	      sandboxLabel5: 'Format',
	      sandboxResponse: 'API Response',
	
	      sdkTittle1: 'Build SDK',
	      sdkTittle2: 'Download SDK',
	      sdkSuccess: 'The SDK is being generated. It will take about 5 minutes. Please be patient and refresh the page.',
	      sdkBuidTime: 'The birth time',
	
	      trafficStatContent: 'Diagram',
	      trafficStatTittle2: 'Error count',
	
	      pageUpdateCancel: 'Cancel',
	      pageUpdateSave: 'Save',
	
	      applyListTh1: 'AppName',
	      applyListTh2: 'Scenario Name',
	      applyListTh3: 'Apply Time',
	      applyListTh4: 'Apply Status',
	      applyListStatus0: 'Approved',
	      applyListStatus1: 'Failed',
	      applyListData: 'No Data',
	
	      pageLogViewSelected: 'Please Select',
	      pageLogViewSelectedScene: '﻿Please select the scene first',
	      pageLogViewSelectedAPI: '﻿Please select the API',
	      pageLogViewSelectedTime: '﻿Please select the time',
	      pageLogViewSearchEmpty: 'The search results are empty',
	      pageLogViewStartTime: 'Please select the time frame',
	      pageLogViewAbnormalShow: 'Display exception only',
	      pageLogViewClientIp: 'Client IP',
	      pageLogViewCode: 'Code',
	      pageLogViewSearchReminder: 'Please Search',
	      pageLogViewSearchBtn: 'Search',
	      pageLogViewSearchResult: 'The Search Results',
	      pageLogViewSearchResult1: 'Total',
	      pageLogViewSearchResult2: '',
	      pageLogViewPrePage: 'Prev',
	      pageLogViewNextPage: 'Next',
	
	      pageCallChart1: 'Api call count',
	      pageCallChart2: 'Api call maximum time consuming',
	      pageCallChart3: 'Api call error rate',
	      pageCallChart4: 'API error code distribution',
	      oneHour: 'One hour',
	      oneDay: 'One day',
	      tenDays: 'Ten days'
	    },
	    API: {
	      ApiListTittle1: 'API Name',
	      ApiListTittle2: 'API Description',
	      sideNavTittle1: 'API Group',
	      sideNavTittle2: 'Business Scenario'
	    },
	    Register: {
	      name: 'Name',
	      phone: 'Phone Number',
	      area: 'Area Number',
	      MesCode: 'Verification Code',
	      sendMesCode: 'sendMesCode',
	      mail: 'Email',
	      companyName: 'Company Name',
	      adress: 'Exact Address',
	      country: 'Country',
	      selectCountry: 'Please select country ...',
	      option: 'Please select ...',
	      detailAdress: 'Detail Adress',
	      agree: 'I agree with',
	      agreement: '《Developer agreement for the xiaomi web development platform》',
	      submit: 'Submit',
	      confirmTittle: 'You have become a developer through the application.',
	      confirmdesc: 'Try to create your applications immediately',
	      milogin: 'XiaoMi Account Login',
	      devapp: 'Developers Application',
	      proau: 'Profile Audit'
	    }
	  },
	  zh: {
	    Register: {
	      name: '开发者姓名',
	      phone: '手机号码',
	      area: '区号',
	      MesCode: '验证码',
	      sendMesCode: '发送验证码',
	      mail: '企业邮箱',
	      companyName: '公司名称',
	      adress: '公司地址',
	      country: '国家',
	      selectCountry: '请选择国家',
	      option: '请选择',
	      detailAdress: '详细地址',
	      agree: '我已点击阅',
	      agreement: '《小米网开发平台开发者协议》',
	      submit: '提交',
	      confirmTittle: '申请通过，您已成为开发者',
	      confirmdesc: '立即创建属于您的应用',
	      milogin: '小米账号登录',
	      devapp: '开发者申请',
	      proau: '资料审核'
	    },
	    Homepage: {
	      services1: '仓储服务',
	      instruction1: '提供小米网强大的仓储物流服务',
	      services2: '售后服务',
	      instruction2: '让复杂的售后业务变的简单',
	      services3: '退款服务',
	      instruction3: '成熟、可靠的退款服务',
	      services4: '其他服务',
	      instruction4: '其他服务'
	    },
	    Content: {
	      tittle1: '商务合作',
	      subtittle11: '业务范围:',
	      subcontent11: '小米网开放平台会开放一些与电商服务有关的API，包括订单、仓储、售后、客服等。如您的公司和小米有商业来往，需要使用上述的一些服务，可与我们联系。',
	      subtittle12: '联系邮箱:',
	      subcontent12: 'OPEN-API@xiaomi.com',
	
	      tittle2: '使用问题',
	      subtittle21: '技术问题:',
	      subcontent21: '如您在使用小米网开放平台遇到任何技术问题，比如：API申请、SDK使用、访问权限等。请与我们联系。',
	      subtittle22: '联系邮箱:',
	      subcontent22: 'OPEN-API@xiaomi.com',
	
	      tittle3: '接入申请',
	      subtittle31: '申请疑问:',
	      subcontent31: '在您申请成为开发者、创建应用、API等过程中，若对申请流程有任何疑问，请与我们联系。',
	      subtittle32: '联系邮箱:',
	      subcontent32: 'OPEN-API@xiaomi.com',
	
	      tittle4: '开放平台交流群',
	      subtittle4: 'QQ群：226281810'
	    },
	    dashboard: {
	      ApiListTittle1: '业务场景',
	      ApiListTittle2: '描述',
	      ApiListTittle3: '操作',
	      AppListStatus0: '申请',
	      AppListStatus1: '审核中',
	      AppListStatus2: '审核通过',
	      AppListStatus3: '已拒绝',
	
	      PageMyApplyStatus0: '审核中',
	      PageMyApplyStatus1: '审核通过',
	      PageMyApplyStatus2: '审核拒绝',
	
	      AppListData: '暂无数据',
	      view: '查看',
	      edit: '编辑',
	      delete: '删除',
	      appListTittle1: '名称',
	      appListTittle2: '状态',
	      appListTittle3: '描述',
	      appListTittle4: '操作',
	      appListStatus: '已通过',
	      appListDelete: '确认删除',
	      appListCancel: '取消',
	      appListSave: '确认',
	
	      appNavList1: '应用概览',
	      appNavList2: 'API申请',
	      appNavList3: 'SDK管理',
	
	      appNavList5: '日志查看',
	      appNavList6: '调用详情',
	
	      navLink1: '应用列表',
	      navLink2: '我的申请',
	      navLink3: '沙箱测试',
	      noApiData: '您尚未调用过任何API，暂无统计数据',
	      pageAddLabel1: '应用名称',
	      pageAddLabel2: '描述',
	      pageAddLabel3: 'IP 白名单',
	      pageAddLabel3Tips: '多个ip请使用分号隔开,网段使用掩码格式记录,如:10.236.134.0/24',
	      pageAddLabel4: '流量',
	      pageAddInvalid1: '不能为空',
	      pageAddInvalid2: '不是正确的ip地址',
	      pageAddInvalid3: '不能大于1000000',
	      pageAddSubmit: '提交',
	
	      pageAppDetail1: '访问流量',
	      pageAppDetail2: 'API调用次数',
	      pageAppDetail3: 'API错误率',
	      newtab: '新建应用',
	
	      sandboxLabel1: 'API 组：',
	      sandboxLabel2: 'API 名称',
	
	      sandboxLabel3: '数据环境：',
	      sandboxLabel4: 'API请求参数',
	      sandboxLabel5: '参数格式',
	      sandboxResponse: 'API 返回结果',
	
	      sdkTittle1: '构建 SDK',
	      sdkTittle2: '下载 SDK',
	      sdkSuccess: 'SDK 正在生成，这大概需要 5 分钟，请耐心等待，刷新页面。',
	      sdkBuidTime: '生成时间',
	
	      trafficStatContent: '图表',
	      trafficStatTittle2: '错误数统计',
	
	      pageUpdateCancel: '取消',
	      pageUpdateSave: '保存',
	
	      applyListTh1: '应用名称',
	      applyListTh2: '场景名称',
	      applyListTh3: '申请时间',
	      applyListTh4: '申请状态',
	      applyListStatus0: '申请成功',
	      applyListStatus1: '未通过',
	      applyListData: '暂无数据',
	      selectOption: '请选择场景与API以查看相应统计数据',
	      pageLogViewSelected: '请选择',
	      pageLogViewSelectedScene: '﻿请先选择场景',
	      pageLogViewSelectedAPI: '﻿请选择API',
	      pageLogViewSelectedTime: '﻿请选择时间',
	      pageLogViewSearchEmpty: '搜索结果为空',
	      pageLogViewStartTime: '请选择时间段',
	      pageLogViewAbnormalShow: '只显示异常',
	      pageLogViewClientIp: 'client_ip',
	      pageLogViewCode: 'code',
	      pageLogViewSearchReminder: '请搜索',
	      pageLogViewSearchBtn: '搜索',
	      pageLogViewSearchResult: '搜索结果',
	      pageLogViewSearchResult1: '共',
	      pageLogViewSearchResult2: '条',
	      pageLogViewPrePage: '上一页',
	      pageLogViewNextPage: '下一页',
	
	      pageCallChart1: 'Api调用次数',
	      pageCallChart2: 'Api调用最大耗时',
	      pageCallChart3: 'Api调用错误率',
	      pageCallChart4: 'API错误code分布',
	      oneHour: '1小时',
	      oneDay: '1天',
	      tenDays: '10天'
	    },
	    API: {
	      ApiListTittle1: '名称',
	      ApiListTittle2: '描述',
	      sideNavTittle1: 'API 组',
	      sideNavTittle2: '使用场景'
	    }
	  }
	};
	
	var i18n = new _vueI18n2.default({
	  locale: 'zh',
	  messages: messages
	});
	exports.default = i18n;

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setCookie;
	function setCookie() {
	  var key = arguments.length <= 0 ? undefined : arguments[0];
	  var value = arguments.length <= 1 ? undefined : arguments[1];
	  var o = arguments.length <= 2 ? undefined : arguments[2];
	  var options = void 0;
	
	  if (arguments.length > 1 && String(value) !== '[object Object]') {
	    var days = void 0;
	    var t = void 0;
	    options = jQuery.extend({}, o);
	
	    if (value === null || value === undefined) {
	      options.expires = -1;
	    }
	
	    if (typeof options.expires === 'number') {
	      days = options.expires;
	      t = options.expires = new Date();
	
	      t.setDate(t.getDate() + days);
	    }
	
	    value = String(value);
	    return document.cookie = [encodeURIComponent(key), '=', options.raw ? value : encodeURIComponent(value), options.expires ? '; expires=' + options.expires.toUTCString() : '', options.path ? '; path=' + options.path : '', options.domain ? '; domain=' + options.domain : '', options.secure ? '; secure' : ''].join('');
	  }
	
	  options = value || {};
	  var decode = !options.raw ? decodeURIComponent : function decode(s) {
	    return s;
	  };
	  var result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie);
	
	  return result ? decode(result[1]) : null;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'SiteFooter',
	  data: function data() {
	    return {
	      lang: 'zh',
	      messages: {
	        en: {
	          colophon: '',
	          contact: 'Contact Us'
	        },
	        zh: {
	          colophon: '<span>小米科技</span> <span>京ICP备10046444号</span> <span>京公网安备11010802020134号</span>',
	          contact: '联系我们'
	        }
	      }
	    };
	  },
	  created: function created() {
	    if (location.href.indexOf('/en') !== -1) {
	      this.lang = 'en';
	    } else {
	      this.lang = 'zh';
	    }
	  }
	};

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'SiteHeader',
	  data: function data() {
	    return {
	      lang: 'zh',
	      website: '' + ("china"),
	      websites: {
	        china: {
	          name: 'china',
	          lang: 'zh',
	          url: 'http://open.be.mi.com',
	          title: '中国'
	        },
	        india: {
	          name: 'india',
	          lang: 'en',
	          url: 'http://in.open.be.mi.com',
	          title: 'india'
	        },
	        singapore: {
	          name: 'singapore',
	          lang: 'en',
	          url: 'http://sg.open.be.mi.com',
	          title: 'singapore'
	        },
	        russia: {
	          name: 'russia',
	          lang: 'en',
	          url: 'http://ru.open.be.mi.com',
	          title: 'russia'
	        }
	      },
	      messages: {
	        en: {
	          siteName: 'XiaoMi Open API Platform',
	          navApi: 'API Documentation',
	          navDoc: 'Instruction',
	          navDashboard: 'Console',
	          login: 'Login',
	          logout: 'Logout'
	        },
	        zh: {
	          siteName: '小米网开放平台',
	          navApi: 'API 文档',
	          navDoc: '使用文档',
	          navDashboard: '控制台',
	          login: '登录',
	          logout: '退出'
	        }
	      }
	    };
	  },
	
	  methods: {
	    goLogin: function goLogin() {
	      localStorage.removeItem('apiCategoryData');
	      event.preventDefault();
	      location.href = ("https://fopen.be.mi.com") + '/' + this.lang + '/login?follow_up=' + encodeURIComponent(location.href);
	    },
	    goLogout: function goLogout() {
	      localStorage.removeItem('apiCategoryData');
	      event.preventDefault();
	      location.href = ("https://fopen.be.mi.com") + '/' + this.lang + '/logout?follow_up=' + encodeURIComponent(location.href);
	    },
	    goIndex: function goIndex() {
	      location.href = ("http://open.be.mi.com") + '/#/' + this.lang;
	    },
	    changeLang: function changeLang(event) {
	      var tmp = $(event.target).val();
	      this.lang = tmp;
	      localStorage.removeItem('apiCategoryData');
	      localStorage.setItem('local', this.lang);
	      location.href = ("http://open.be.mi.com") + '/#/' + this.lang;
	    },
	    travel: function travel(event) {
	      var name = $(event.target).val();
	      var web = this.websites[name];
	      this.lang = web.lang;
	      var tmpHref = web.url + '/#/' + web.lang;
	      localStorage.removeItem('apiCategoryData');
	      localStorage.setItem('local', this.lang);
	      location.href = tmpHref;
	    }
	  },
	  created: function created() {
	    if (location.href.indexOf('/zh') !== -1) {
	      this.lang = 'zh';
	    } else {
	      this.lang = 'en';
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(181),
	  /* template */
	  __webpack_require__(692),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(344)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(182),
	  /* template */
	  __webpack_require__(704),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 692:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "site-footer"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('p', {
	    staticClass: "footer-desc",
	    domProps: {
	      "innerHTML": _vm._s(this.messages[this.lang].colophon)
	    }
	  }), _vm._v(" "), _c('nav', {
	    staticClass: "footer-nav"
	  }, [_c('a', {
	    attrs: {
	      "href": '/contact.html#/' + this.lang
	    }
	  }, [_vm._v(_vm._s(this.messages[this.lang].contact))])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 704:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "site-header"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('a', {
	    staticClass: "site-logo",
	    on: {
	      "click": _vm.goIndex
	    }
	  }, [_c('span', {
	    staticClass: "logo"
	  }), _vm._v(_vm._s(this.messages[this.lang].siteName))]), _vm._v(" "), _c('nav', {
	    staticClass: "site-nav"
	  }, [_c('a', {
	    attrs: {
	      "href": '/api.html#/' + this.lang
	    }
	  }, [_vm._v(_vm._s(this.messages[this.lang].navApi))]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": '/dashboard.html#/' + this.lang
	    }
	  }, [_vm._v(_vm._s(this.messages[this.lang].navDashboard))]), _vm._v(" "), (this.$parent.isLogin) ? _c('div', {
	    staticClass: "user-info"
	  }, [_c('i', {
	    staticClass: "icon icon-user"
	  }), _c('span', {
	    staticClass: "username"
	  }, [_vm._v(_vm._s(this.$parent.userName))]), _c('span', {
	    staticClass: "sep"
	  }, [_vm._v("|")]), _c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.goLogout
	    }
	  }, [_vm._v(_vm._s(this.messages[this.lang].logout))])]) : _c('div', {
	    staticClass: "user-info"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.goLogin
	    }
	  }, [_vm._v(_vm._s(this.messages[this.lang].login))])]), _vm._v(" "), _c('div', {
	    staticClass: "user-info"
	  }, [_c('select', {
	    on: {
	      "change": _vm.travel
	    }
	  }, _vm._l((this.websites), function(item, index) {
	    return _c('option', {
	      key: index,
	      domProps: {
	        "value": item.name,
	        "selected": item.name == _vm.website
	      }
	    }, [_vm._v("\n            " + _vm._s(item.title) + "\n          ")])
	  }), 0)])])])])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/main.b8bf308348e0535d1c90.js